import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ReportService } from './report.service';
import { catchError } from 'rxjs/operators';
import { APP_CONSTANTS } from '../../app.constants';

export interface HasReportsResponse {
    expired: boolean;
    hasReports: boolean;
}

export interface DeleteFileRequest {
    bucket: string;
    guid: string;
    id: number;
}

export interface DeleteFileResponse {
    success: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ReportManagementService {
    // Shared API URL prefix sourced from APP_CONSTANTS so the "/api" mount
    // point is not hard-coded throughout this service.
    private readonly API_PREFIX = APP_CONSTANTS.API_PREFIX;

    constructor(
        private reportService: ReportService,
        private http: HttpClient
    ) {}
    // any handles error
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private handleError(error: Response | any): any {
        console.error('ApiService::handleError', error);
        return throwError(() => new Error(error));
    }

    public getAllReports(): Observable<any> {
        return this.http
            .get<any>(`${this.API_PREFIX}/reportManagement/getAllReports`, {
                params: {
                    id: this.reportService.currentLibrary
                }
            })
            .pipe<any>(catchError(this.handleError));
    }

    public hasReports(): Observable<HasReportsResponse> {
        return this.http
            .get<HasReportsResponse>(`${this.API_PREFIX}/reportManagement/hasReports`, {
                params: {
                    id: this.reportService.currentLibrary
                }
            })
            .pipe<any>(catchError(this.handleError));
    }

    public deleteFile(file: DeleteFileRequest): Observable<DeleteFileResponse> {
        return this.http
            .post<DeleteFileResponse>(`${this.API_PREFIX}/reportManagement/deleteFile`, {
                file
            })
            .pipe<any>(catchError(this.handleError));
    }
}
